import axios from 'axios';

/**
 * API client. In dev the CRA proxy forwards /api to localhost:8080;
 * in production REACT_APP_BACKEND_URL points at the deployed backend.
 */
const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || '',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('bp-token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !err.config.url.includes('/auth/')) {
      localStorage.removeItem('bp-token');
      localStorage.removeItem('bp-user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const errMsg = (err, fallback) =>
  err.response?.data?.error || err.message || fallback || 'Something went wrong';

export default api;
